import {
  AddUserResponse,
  Team,
  TeamTree,
} from 'src/pages/budget/budgetTeams/types'


export const addUsersToTeamList = (
  teams: Team[],
  addedUsers: AddUserResponse,
): Team[] => {
  if (addedUsers.length === 0) return teams

  const { teamId, permissionType } = addedUsers[0]
  const userIds = addedUsers.map((u) => u.userId)

  return teams.map((team) => {
    if (team.id !== teamId) return team

    return {
      ...team,
      permissions: {
        ...team.permissions,
        [permissionType]: [...team.permissions[permissionType], ...userIds],
      },
    }
  })

}

export function formatTeamsToTree(teamList: Team[]): TeamTree[] {
  const map = new Map<number, TeamTree>()
  const roots: TeamTree[] = []

  for (const team of teamList) {
    map.set(team.id, { ...team, level: 0 })
  }

  for (const team of teamList) {
    const node = map.get(team.id)!

    if (team.parentTeamId !== null) {
      const parentNode = map.get(team.parentTeamId)

      if (parentNode) {
        Array.isArray(parentNode.children)
          ? parentNode.children.push(node)
          : (parentNode.children = [node])
      }
    } else {
      roots.push(node)
    }
  }

  const setLevel = (node: TeamTree, level: number) => {
    node.level = level
    node.children?.forEach((child) => setLevel(child, level + 1))
  }

  roots.forEach((root) => setLevel(root, 0))

  return roots
}
